<i18n>
{
  "en": {
    "menusError": "Error loading menu list. Please, try again later.",
    "createMenuError": "Error creating menu. Please, try again later.",
    "deleteMenuError": "Error deleting menu \"{0}\". Please, try again later.",
    "editMenuError": "Error editing menu \"{0}\". Please, try again later.",
    "publishMenuError": "Error publishing menu \"{0}\". Please, try again later.",
    "publishPreviousError": "Menu publication generated with errors. Showing old publication, try again later.",
    "publishLoading": "Publishing menu",
    "restrictionError": "Menu \"{0}\" can't be published since it's in the middle of a service. Please, try again at {1}.",
    "appearanceMenuError": "Error editing menu's theme appearance. Please, try again later.",
    "createMenuSuccess": "Created \"{0}\" menu!",
    "appearanceMenuSuccess": "Menu's theme appearance was successfully edited!",
    "editMenuSuccess": "Menu \"{0}\" was successfully edited!",
    "deleteMenuSuccess": "Menu \"{0}\" was deleted",
    "menus": "Menus",
    "menu": "Menu",
    "edit": "Edit",
    "delete": "Delete",
    "configure": "Configure",
    "restaurant": "Restaurant",
    "menuAdvisor": "Menu Advisor",
    "deleteMenuTitle": "Do you want to delete \"{0}\" menu ?",
    "deleteMenuDescription": "This can not be undone",
    "noData": "Add menus",
    "orderByPriority": "Order by priority",
    "orderByDate": "Order by creation date",
    "filterByMoment": "Filter by time",
    "filterByZone": "Filter by zone",
    "filter": "Filter by",
    "order": "Order by",
    "priority": "Priority",
    "creationDate": "Creation Date",
    "managedStatus": "Revenue Management status",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "defaultZone": "All zones",
    "defaultMoment": "All moments",
    "add": "Add new",
    "publicationInProgress": "There is a publication in progress for this menu, try it again later",
    "settingsMenuError": "Error editing menu's theme settings. Please, try again later.",
    "settingsMenuSuccess": "Menu's theme settings was successfully edited!",
    "printMenuError": "Error loading print of menu products. Please, try again later",
    "generatingPrintOfMenu": "Generating menu for printing"
  },
  "es": {
    "menusError": "Error cargando datos de los menús. Inténtelo de nuevo más tarde.",
    "createMenuError": "Error al crear el menú. Inténtelo de nuevo más tarde.",
    "deleteMenuError": "Error al borrar el menú \"{0}\". Inténtelo de nuevo más tarde.",
    "editMenuError": "Error al editar el menú \"{0}\". Inténtelo de nuevo más tarde.",
    "publishLoading": "Publicando el menú",
    "publishMenuError": "Error al publicar el menú \"{0}\". Inténtelo de nuevo más tarde.",
    "publishPreviousError": "La publicación del menú \"{0}\" se generó con errores. Mostrando publicación antigua, inténtelo de nuevo más tarde.",
    "restrictionError": "No se puede publicar el menú \"{0}\" porque está en medio de un servicio. Inténtelo de nuevo a la{2} {1}.",
    "appearanceMenuError": "Error al editar la apariencia del tema del menú. Inténtelo de nuevo más tarde.",
    "createMenuSuccess": "Menu \"{0}\" creado",
    "editMenuSuccess": "El menú \"{0}\" se editó correctamente",
    "appearanceMenuSuccess": "La apariencia del tema del menú se editó correctamente",
    "deleteMenuSuccess": "El menú \"{0}\" fue borrado",
    "menus": "Menús",
    "menu": "Menú",
    "edit": "Editar",
    "delete": "Eliminar",
    "configure": "Configurar",
    "restaurant": "Restaurante",
    "menuAdvisor": "Menu Advisor",
    "deleteMenuTitle": "¿Desea borrar el menú \"{0}\" ?",
    "deleteMenuDescription": "Este cambio es irreversible",
    "noData": "Añadir menús",
    "orderByPriority": "Ordenar por prioridad",
    "orderByDate": "Ordenar por fecha de creación",
    "filterByMoment": "Filtrar por momento",
    "filterByZone": "Filtrar por zona",
    "filter": "Filtrar por",
    "order": "Ordenar por",
    "priority": "Prioridad",
    "creationDate": "Fecha de creación",
    "managedStatus": "Estado de Revenue Management",
    "enabled": "Activo",
    "disabled": "Inactivo",
    "defaultZone": "Todas las zonas",
    "defaultMoment": "Todos los momentos",
    "add": "Añadir nuevo",
    "publicationInProgress": "Ya hay una publicación en curso para este menú, inténtelo más tarde.",
    "settingsMenuError": "Error al editar los ajustes del tema del menú. Inténtelo de nuevo más tarde.",
    "settingsMenuSuccess": "Los ajustes del tema del menú se editó correctamente",
    "printMenuError": "Error cargando el menu para imprimir. Inténtelo de nuevo más tarde",
    "generatingPrintOfMenu": "Generando el menu para imprimir"
  }
}
</i18n>

<template>
  <div>
    <div class="mx-6 mt-4">
      <div class="d-flex flex-wrap">
        <v-row>
          <v-col class="d-flex" cols="12" md="6" lg="6" xl="6">
            <v-select v-model="selectedOrderBy" :items="selectorOrderTags" :label="this.$t('order')"
                      dense/>
          </v-col>
          <v-col class="d-flex pb-0" cols="6" sm="3">
            <v-select v-model="filterByZoneGuid" :items="saleZoneListWithDefault" item-text="name"
                      item-value="guid"
                      :label="this.$t('filterByZone')" dense/>
          </v-col>
          <v-col class="d-flex pb-0" cols="6" sm="3">
            <v-select v-model="filterByMomentGuid" :items="momentOfConsumeListWithDefault"
                      item-text="name"
                      item-value="guid" :label="this.$t('filterByMoment')" dense/>
          </v-col>
        </v-row>
      </div>
      <div class="d-flex flex-wrap mx-7 mb-1">
        <v-row>
          <v-spacer/>
          <v-col align-self="center" class="pa-0">
            <div class="text-center text-h5 mr-2">
              {{ $t('menus') }}
            </div>
          </v-col>
          <v-col align-self="end" class="pa-0">
            <v-tooltip top v-if="isMenuCreate">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs"
                       @click="onOpenModal('create')">
                  <v-icon color="grey" large>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('add') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-divider/>
    <v-list>
      <menu-create-edit-modal :visible="createModalVisible" @confirm="onCreateMenu"
                              @cancel="onCloseModals"
                              :menu="menuToCreate"/>
      <menu-create-edit-modal :visible="editModalVisible" @confirm="onEditMenu"
                              @cancel="onCloseModals"
                              :menu="menu" type="edit"/>
      <menu-appearance-modal :visible="configureModalVisible" @confirm="onAppearanceMenu"
                             @cancel="onCloseModals"
                             :theme-guid="themeGuidToEdit" :template-guid="templateGuidToFollow"/>
      <menu-settings-modal :visible="settingsModalVisible" @confirm="onSettingsMenu"
                           @cancel="onCloseModals"
                           :template-guid="templateGuidToFollow"
                           :menu-configuration-guid="menuConfigurationGuidToEdit"
                           :menu-guid="menu && menu.guid"
                           :initial-recommendations="menuInitialRecommendationList"/>
      <dynameat-confirmation-modal :visible="deleteModalVisible"
                                   :title="$t('deleteMenuTitle', [menuToDeleteTitle])"
                                   :description="$t('deleteMenuDescription')"
                                   :confirm-text="$t('delete')"
                                   @confirm="onDeleteMenu"
                                   @cancel="onCloseModals"/>
      <dynameat-confirmation-modal :visible="publishModalLoadingVisible"
                                   :title="$t('publishLoading')"
                                   :is-loading="isLoading"/>
      <print-menu-modal
        :visible="printMenuModalVisible"
        :selectedMenu="menu"
        @cancel="onCloseModals"
        @confirm="onConfirmPrintMenu"/>
      <grid-generator-modal
        :visible="gridGeneratorVisible"
        :menu="menu"
        @cancel="onCloseModals"
      />
      <div v-if="!isLoading" class="mb-10">
        <menu-row v-for="menu in menuListFiltered" :key="menu.guid" :menu="menu"
                  @publish="onPublish(menu)"
                  @preview-publication="onPreview(menu.publication, menu)"
                  @edit="onOpenModal('edit', menu)"
                  @configure="onOpenModal('configure', menu)"
                  @settings="onOpenModal('settings', menu)"
                  @delete="onOpenModal('delete', menu)"
                  @click-content="onGoToMenuSections(menu)"
                  @print-menu="onOpenModal('printMenuModalVisible', menu)"
                  @grid-config="onOpenModal('gridGenerator', menu)"
        />
      </div>
      <dynameat-skeleton v-else skeleton-type="manualConfigList" :container="false"/>
      <dynameat-confirmation-modal :visible="outOfMenuLoading" :title="$t('generatingPrintOfMenu')"
                                   description="" confirm-text="" :is-loading="outOfMenuLoading"/>
    </v-list>
    <div v-if="emptyMenuList && !isLoading" class="empty-data">
      <p class="grey--text">{{ this.$t('noData') }}</p>
    </div>
  </div>
</template>

<script>
import {
  createErrorNotification,
  createSuccessNotification,
  createWarningNotification
} from '@ulibs/unnotificationsqueue';
import { Menu, SaleZone } from '@dynameat/views/pointOfSale/models';
import DynameatSkeleton from '@dynameat/components/DynameatSkeleton';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { getFormatDate } from '@core/helpers/dates';
import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { generationStatus } from '@menurender/constants';
import { printMenuRequest } from '@fileExport/requests';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import GridGeneratorModal from '@menuGridGenerator/menuGridGeneratorModal.vue';
import MenuRow from '../components/MenuRow.vue';
import MenuCreateEditModal from '../components/MenuCreateEditModal.vue';
import MenuAppearanceModal from '../components/MenuAppearanceModal.vue';
import MenuSettingsModal from '../components/MenuSettingsModal.vue';
import PrintMenuModal from '../components/PrintMenuModal.vue';
import { MomentOfConsume } from '../models';
import { getDeployedPublication } from '../processes';

Component.registerHooks(['beforeRouteLeave']);
@Component
@Components({
  DynameatSkeleton,
  DynameatConfirmationModal,
  MenuRow,
  MenuCreateEditModal,
  MenuAppearanceModal,
  MenuSettingsModal,
  PrintMenuModal,
  GridGeneratorModal
})
@MapGetters(['menuList', 'saleZoneList', 'momentOfConsumeList', 'isLoading', 'templateList',
  'currentMenu', 'menuInitialRecommendationList', 'pointOfSaleLanguages', 'moduleFunctionalities'])
@MapActions(['addNotification', 'menuListRequest', 'createMenuRequest', 'editMenuRequest',
  'deleteMenuRequest', 'editThemeRequest', 'editMenuConfigurationRequest', 'setLoading', 'publishMenuRequest',
  'updateMenuPublication', 'editMenu', 'createRecommendation', 'editRecommendation',
  'recommendationListRequest', 'deleteRecommendation', 'menuGridConfigurationRequest'])
export default class MenuList extends Vue {
  menuToCreate = null;

  menu = null;

  menuGuidToEdit = null;

  menuToDelete = null;

  themeGuidToEdit = null;

  menuConfigurationGuidToEdit = null;

  templateGuidToFollow = null;

  createModalVisible = false;

  editModalVisible = false;

  configureModalVisible = false;

  settingsModalVisible = false;

  deleteModalVisible = false;

  printMenuModalVisible = false;

  filterByZoneGuid = null;

  filterByMomentGuid = null;

  publishModalLoadingVisible = false;

  waiter = null;

  selectedOrderBy = 'creationDate';

  outOfMenuLoading = false;

  gridGeneratorVisible = false;

  get saleZoneListWithDefault() {
    return [SaleZone.toInstance({
      guid: undefined,
      name: this.$t('defaultZone')
    }), ...this.saleZoneList];
  }

  get momentOfConsumeListWithDefault() {
    return [MomentOfConsume.toInstance({
      guid: undefined,
      name: this.$t('defaultMoment')
    }), ...this.momentOfConsumeList];
  }

  get isMenuCreate() {
    return this.moduleFunctionalities.includes('createMenu');
  }

  get menuListFiltered() {
    let { menuList } = this;
    if (this.selectedOrderBy === 'priority') {
      menuList = [...this.menuList].sort((menuA, menuB) => (menuA.priority < menuB.priority ? 1 : -1));
    }
    if (this.filterByZoneGuid) menuList = menuList.filter((menu) => menu.sale_zones.includes(this.filterByZoneGuid));
    if (this.filterByMomentGuid) menuList = menuList.filter((menu) => menu.moments_of_consume.includes(this.filterByMomentGuid));
    return menuList;
  }

  get menuToDeleteTitle() {
    return this.menuToDelete ? this.menuToDelete.title : '';
  }

  get emptyMenuList() {
    return this.menuList.length === 0;
  }

  get selectorOrderTags() {
    return [{ text: this.$t('creationDate'), value: 'creationDate' },
      { text: this.$t('priority'), value: 'priority' }];
  }

  get sizeWindowMap() {
    return {
      '16 / 9': { width: '1366', height: '768' },
      '9 / 16': { width: '567', height: '1008' },
      '4 / 3': { width: '1280', height: '960' },
      '3 / 2': { width: '1275', height: '850' },
      '21 / 9': { width: '1288', height: '552' },
      '1.85 / 11': { width: '90', height: '990' },
    };
  }

  async created() {
    await this.getMenuListData();
    await this.recommendationListRequest(this.$route.params.pointOfSaleGuid);
  }

  beforeRouteLeave(to, from, next) {
    if (this.waiter) this.waiter.forceClear();
    if (this.isLoading) {
      this.setLoading(-1);
    }
    next();
  }

  @Watch('$route')
  onRouteChange(to, from) {
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) this.getMenuListData();
  }

  async getMenuListData() {
    try {
      await this.setLoading(1);
      await this.menuListRequest(this.$route.params.pointOfSaleGuid);
      await this.setLoading(-1);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('menusError')));
    }
  }

  async onGoToMenuSections(menu) {
    await this.editMenu(menu);
    this.$router.push({ name: 'menuEditor', params: { menuGuid: menu.guid } });
  }

  async onOpenModal(type, menu) {
    switch (type) {
      case 'create':
        this.menuToCreate = Menu.toInstance({ point_of_sale: this.$route.params.pointOfSaleGuid });
        this.createModalVisible = true;
        break;
      case 'edit':
        const props = menu.serialize();
        this.menu = Menu.toInstance(props);
        this.editModalVisible = true;
        break;
      case 'configure':
        this.templateGuidToFollow = menu.template;
        this.themeGuidToEdit = menu.theme;
        this.menuConfigurationGuidToEdit = menu.menu_configuration;
        this.configureModalVisible = true;
        break;
      case 'settings':
        const dataMenu = menu.serialize();
        this.menu = Menu.toInstance(dataMenu);
        this.menuGuidToEdit = this.menu.guid;
        this.templateGuidToFollow = menu.template;
        this.themeGuidToEdit = menu.theme;
        this.menuConfigurationGuidToEdit = menu.menu_configuration;
        this.settingsModalVisible = true;
        break;
      case 'delete':
        this.deleteModalVisible = true;
        this.menuToDelete = menu;
        break;
      case 'printMenuModalVisible':
        const printMenu = menu.serialize();
        this.menu = Menu.toInstance(printMenu);
        this.printMenuModalVisible = true;
        break;
      case 'gridGenerator':
        const menuData = menu.serialize();
        this.menu = Menu.toInstance(menuData);
        this.gridGeneratorVisible = true;
        break;
    }
  }

  onCloseModals() {
    this.createModalVisible = false;
    this.editModalVisible = false;
    this.configureModalVisible = false;
    this.settingsModalVisible = false;
    this.deleteModalVisible = false;
    this.publishModalLoadingVisible = false;
    this.printMenuModalVisible = false;
    this.gridGeneratorVisible = false;
  }

  async onCreateMenu(menu) {
    try {
      const createdMenu = await this.createMenuRequest(menu);
      this.addNotification(createSuccessNotification(this.$t('createMenuSuccess', [menu.title]), null));
      this.onGoToMenuSections(createdMenu);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createMenuError', [menu.title])));
    } finally {
      this.onCloseModals();
      this.menuToCreate = null;
    }
  }

  async onPublish(menu) {
    try {
      this.setLoading(1);
      this.publishModalLoadingVisible = true;
      const publicationGuid = await this.publishMenuRequest(menu.guid);
      await this.publishing(menu, publicationGuid);
    } catch (err) {
      this.setLoading(-1);
      if (err.response.status === 409) {
        const time = err.response.data.time_to.split(':').slice(0, 2);
        this.addNotification(createErrorNotification(this.$t('restrictionError',
          [menu.title, `${time[0]}:${time[1]}`, time[0] === 1 ? '' : 's'])));
      } else if (err.response.status === 202) {
        this.addNotification(createWarningNotification(this.$t('publicationInProgress'), {}, 7000));
      } else {
        this.addNotification(createErrorNotification(this.$t('publishMenuError', [menu.title])));
      }
    } finally {
      this.onCloseModals();
    }
  }

  async publishing(menu, publicationGuid) {
    this.waiter = getDeployedPublication(publicationGuid);
    const updatedPublication = await this.waiter.initialize();
    this.updateMenuPublication({ menuGuid: menu.guid, updatedPublication });
    if (updatedPublication.generation_status === generationStatus.withErrors) {
      this.addNotification(createErrorNotification(this.$t('publishPreviousError', [menu.title])));
    }
    this.onPreview(updatedPublication, menu);
    this.publishModalLoadingVisible = false;
    this.setLoading(-1);
  }

  async onPreview(publication, menu) {
    const publicationUrl = `${publication.publication_info_by_zone[0].publication_link}&avoidRedirect=true`;
    const template = this.templateList.find((el) => el.guid === menu.template);
    let { width, height } = template.getWidthAndHeight();

    if (menu.grid_configuration) {
      const menuGridConf = await this.menuGridConfigurationRequest(menu.grid_configuration);
      width = this.sizeWindowMap[menuGridConf.aspectRatio].width;
      height = this.sizeWindowMap[menuGridConf.aspectRatio].height;
    }
    window.open(publicationUrl, 'menu', `toolbar=0,menubar=1,resizable=0,width=${width},height=${height}`);
  }

  async onEditMenu(menu) {
    try {
      await this.editMenuRequest(menu);
      this.addNotification(createSuccessNotification(this.$t('editMenuSuccess', [menu.title]), null));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('editMenuError', [menu.title])));
    } finally {
      this.onCloseModals();
      this.menu = null;
    }
  }

  async onAppearanceMenu(theme) {
    try {
      await this.editThemeRequest(theme);
      this.addNotification(createSuccessNotification(this.$t('appearanceMenuSuccess'), null));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('appearanceMenuError')));
    } finally {
      this.onCloseModals();
      this.themeGuidToEdit = null;
    }
  }

  async onSettingsMenu({
    menuConfiguration, initialRecommendations, deletedInitialRecommendations
  }) {
    try {
      await this.editMenuConfigurationRequest(menuConfiguration);
      for (const recommendation of initialRecommendations) {
        if (recommendation.guid) {
          await this.editRecommendation(recommendation);
        } else {
          await this.createRecommendation(recommendation);
        }
      }

      for (const deletedRecommendation of deletedInitialRecommendations) {
        await this.deleteRecommendation(deletedRecommendation);
      }

      this.addNotification(createSuccessNotification(this.$t('settingsMenuSuccess'), null));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('settingsMenuError')));
    } finally {
      this.onCloseModals();
      this.themeGuidToEdit = null;
      this.menuConfigurationGuidToEdit = null;
    }
  }

  async onDeleteMenu() {
    try {
      await this.deleteMenuRequest(this.menuToDelete);
      this.addNotification(createSuccessNotification(this.$t('deleteMenuSuccess', [this.menuToDelete.title]), null));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('deleteMenuError', [this.menuToDelete.title]), null));
    } finally {
      this.onCloseModals();
      this.menuToDelete = null;
    }
  }

  getSelectLanguage(guid) {
    return this.pointOfSaleLanguages.find((language) => language.guid === guid);
  }

  async onConfirmPrintMenu({ printMenuFormData }) {
    this.outOfMenuLoading = true;
    const windowRef = window.open();
    try {
      const printMenu = await printMenuRequest({
        selectDay: getFormatDate(printMenuFormData.date),
        serviceGuid: printMenuFormData.selectedService,
        saleZoneGuid: printMenuFormData.selectedZone,
        languageGuid: printMenuFormData.selectedLanguage,
        menuGuid: printMenuFormData.selectedMenu,
        selectedSections: printMenuFormData.selectedSections
      });
      printMenu.menuLanguage = this.getSelectLanguage(printMenuFormData.selectedLanguage);
      printMenu.printWindow(windowRef);
    } catch (e) {
      console.log('error', e);
      windowRef?.close();
      this.addNotification(createErrorNotification(this.$t('printMenuError'), null));
    } finally {
      this.outOfMenuLoading = false;
    }
  }
}
</script>

<style scoped>
.empty-data {
  text-align: center;
}

.plus-icon {
  float: right;
}
</style>
